const CheckinLocationActionType = {
	/*********  START GET FIELD OFFICER LIST  *********/
	GET_FIELD_OFFICER_LIST_START: 'get_field_officer_list_start',
	GET_FIELD_OFFICER_LIST_SUCCESS: 'get_field_officer_list_success',
	GET_FIELD_OFFICER_LIST_FAILURE: 'get_field_officer_list_failure',
	GET_FIELD_OFFICER_LIST_RESPONSE_RESET: 'get_field_officer_list_response_reset',
	GET_FIELD_OFFICER_LIST_RESPONSE_CHANGED: 'get_field_officer_list_response_changed',
	/*********  END GET FIELD OFFICER LIST  *********/

	/*********  START GET FIELD OFFICER LOCATION DETAILS  *********/
	GET_FIELD_OFFICER_LOCATION_START: 'get_field_officer_location_start',
	GET_FIELD_OFFICER_LOCATION_SUCCESS: 'get_field_officer_location_success',
	GET_FIELD_OFFICER_LOCATION_FAILURE: 'get_field_officer_location_failure',
	GET_FIELD_OFFICER_LOCATION_RESPONSE_RESET: 'get_field_officer_location_response_reset',
	GET_FIELD_OFFICER_LOCATION_RESPONSE_CHANGED: 'get_field_officer_location_response_changed',
	/*********  END GET FIELD OFFICER LOCATION DETAILS  *********/
};

export default CheckinLocationActionType;
